import * as tslib_1 from "tslib";
import * as i0 from "@angular/core";
var ReportsMapperService = /** @class */ (function () {
    function ReportsMapperService() {
    }
    ReportsMapperService.prototype.equalizeFilterQueryParams = function (queryParams) {
        var e_1, _a;
        var initialDate = ['createdAt_gte', 'completedAt_gte'];
        var finalDate = ['createdAt_lte', 'completedAt_lte'];
        var equaledParameters = {};
        try {
            for (var _b = tslib_1.__values(Object.keys(queryParams)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var parameter = _c.value;
                if (initialDate.includes(parameter)) {
                    equaledParameters['createdAt_gte'] = queryParams[parameter];
                }
                if (finalDate.includes(parameter)) {
                    equaledParameters['createdAt_lte'] = queryParams[parameter];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return equaledParameters;
    };
    ReportsMapperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReportsMapperService_Factory() { return new ReportsMapperService(); }, token: ReportsMapperService, providedIn: "root" });
    return ReportsMapperService;
}());
export { ReportsMapperService };
